import { useReducer, useEffect } from "react";
import type { InitLU } from "../../../u2101LogicalUnit/U2101Context";
import u2000LUState, { U2000LUStateEnumAction, type U2000LUState } from "./U2000LUState";
import type { U2101InitLU } from "../../../u2101LogicalUnit/U2101";

// Interface regroupant les handlers pour le form state
export interface U2000LUStateHandlers {
  setPersonnalization: (personalization: Record<string, any>) => void;
  getAllPersonnalization: () => Record<string, any> | undefined;
  getPartialPersonnalization: (keys: string[]) => Record<string, any> | undefined;
  setActionOriginFrom: (actionOriginFrom: string) => void;
  getActionOriginFrom: () => string;
  setNextAction: (nextAction: string) => void;
  getNextAction: () => string;
}

export interface U2000LUStateHandlersParams {
  initLU: U2101InitLU;
}

export interface U2000LUStateHandlersReturn {
  setPersonnalization: (personalization: Record<string, any>) => void;
  getAllPersonnalization: () => Record<string, any> | undefined;
  getPartialPersonnalization: (keys: string[]) => Record<string, any> | undefined;
  setActionOriginFrom: (actionOriginFrom: string) => void;
  getActionOriginFrom: () => string;
  setNextAction: (nextAction: string) => void;
  getNextAction: () => string;
}

export const u2000IntLUState: U2000LUState = {
  personalization: {},
  nextAction: "",
};

export function useU2000LUStateHandlers(params: U2000LUStateHandlersParams = { initLU: {} as U2101InitLU }): U2000LUStateHandlersReturn {
  const [luState, luStateDispatch] = useReducer(u2000LUState, u2000IntLUState);

  const { initLU } = params;

  const init = (initLU: InitLU) => {
    if (initLU) {
      luStateDispatch({ type: U2000LUStateEnumAction.SETPERSONALIZATION, data: { personalization: initLU } });
    }
  };

  const setPersonnalization = (_personalization: Record<string, any>) => {};

  const getAllPersonnalization = () => {
    return luState.personalization;
  };

  const getPartialPersonnalization = (keys: string[]) => {
    if (!luState.personalization) return undefined;

    const partialPersonalization: Record<string, any> = {};
    keys.forEach((key) => {
      if (key in luState.personalization!) {
        partialPersonalization[key] = luState.personalization![key];
      }
    });
    return partialPersonalization;
  };

  const setActionOriginFrom = (actionOriginFrom: string) => {
    luStateDispatch({ type: U2000LUStateEnumAction.ACTIONORIGINFROM, data: { actionOriginFrom } });
  };

  const getActionOriginFrom = (): string => {
    return luState.actionOriginFrom || "";
  };

  const setNextAction = (nextAction: string) => {
    luStateDispatch({ type: U2000LUStateEnumAction.NEXTACTION, data: { nextAction } });
  };

  const getNextAction = (): string => {
    return luState.nextAction;
  };

  useEffect(() => {
    init(initLU);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Appelé une seule fois au montage

  return {
    setPersonnalization,
    getAllPersonnalization,
    getPartialPersonnalization,
    setActionOriginFrom,
    getActionOriginFrom,
    setNextAction,
    getNextAction,
  };
}
